import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PinOverrideGroup } from '@emm/core/models/pin-override-group.model';
import {PinOverride} from '@emm/core/models/pin-override.model';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({ providedIn: 'root' })
export class PinOverridesService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) { }

    public getPinOverrideGroups(): Observable<PinOverrideGroup[]> {
        return this.http.get(`${this.apiUrl}/pin-overrides/groups`).pipe(
            map((response: any) => response['content']),
            standardRetry()
        );
    }

    public getPinOverrideGroup(id: number): Observable<PinOverrideGroup> {
        return this.http.get(`${this.apiUrl}/pin-overrides/groups/${id}/details`).pipe(
            map((response: PinOverrideGroup) => response),
            standardRetry()
        );
    }

    public deletePinOverridesGroupById(id: number): Observable<PinOverrideGroup> {
        return this.http.delete(`${this.apiUrl}/pin-overrides/groups/${id}`).pipe(
            map((response: PinOverrideGroup) => response),
            standardRetry()
        );
    }

    public savePinOverrideGroup(pinOverrideGroup: any): Observable<PinOverrideGroup> { // same method for create and update
        return this.http
            .post(`${this.apiUrl}/pin-overrides`, pinOverrideGroup)
            .pipe(standardRetry());
    }

    public deletePinOverrideById(id: any): Observable<PinOverride> { // delete a single override by id
        return this.http
            .delete(`${this.apiUrl}/pin-overrides/`+id)
            .pipe(standardRetry());
    }

    public getAllPins() {
        return this.http
            .get(`${this.apiUrl}/pin-overrides/report`, { observe: 'body', responseType: 'text' })
            .pipe(standardRetry());
    }

    public getFilteredPins(locationNumber: string, effectiveDate: string) {
        return this.http
            .get(`${this.apiUrl}/pin-overrides/report/${locationNumber}`, {
                params: {effectiveDate}, observe: 'body', responseType: 'text',
            })
            .pipe(standardRetry());
    }

    public publishActivePins(): Observable<any> {
        return this.http
            .post(`${this.apiUrl}/pin-overrides/publish/active`, {})
            .pipe(standardRetry());
    }

    public publishAllPins(forceOverride?: boolean, location?: string): Observable<any> {
        if (forceOverride && location) {
            return this.http
                .post(`${this.apiUrl}/pin-overrides/publish/all?location=${location}&forceOverride=${forceOverride}`, {})
                .pipe(standardRetry());
        } else {
            return this.http
                .post(`${this.apiUrl}/pin-overrides/publish/all`, {})
                .pipe(standardRetry());
        }
    }
}
